import styled from 'styled-components'

export const EmailVerificationContainer = styled.div`
  p {
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    color: ${props => props.theme.colors.black};
  }

  strong {
    font-family: ${props => props.theme.texts.bodyMBold.fontFamily};
    font-size: ${props => props.theme.texts.bodyMBold.fontSize};
    color: ${props => props.theme.colors.black};
  }

  p:nth-child(5) {
    display: none;
  }

  @media screen and (max-width: 500px) {
    button {
      width: 100% !important;
    }
  }
`

export const SubTitle = styled.h3`
  font-family: ${props => props.theme.texts.titleM.fontFamily};
  font-size: ${props => props.theme.texts.titleM.fontSize};
  color: ${props => props.theme.colors.red};
  margin: 0;
`
